import script from "./sf-inpage-list-item.vue?vue&type=script&lang=ts&setup=true&generic=ID%20extends%20string%20%7C%20number%20%7C%20null"
export * from "./sf-inpage-list-item.vue?vue&type=script&lang=ts&setup=true&generic=ID%20extends%20string%20%7C%20number%20%7C%20null"

const __exports__ = script;

export default __exports__